import { CookiesNames } from '@utils/consts';
import type { $Fetch, NitroFetchOptions } from 'nitropack';

interface IHttpFactory {
    method:
        | 'GET'
        | 'HEAD'
        | 'PATCH'
        | 'POST'
        | 'PUT'
        | 'DELETE'
        | 'CONNECT'
        | 'OPTIONS'
        | 'TRACE'
        | 'get'
        | 'head'
        | 'patch'
        | 'post'
        | 'put'
        | 'delete'
        | 'connect'
        | 'options'
        | 'trace';
    url: string;
    fetchOptions?: NitroFetchOptions<'json'>;
    body?: object;
    withToken?: boolean;
}

class HttpFactory {
    private readonly $fetch: $Fetch;

    constructor(fetch: $Fetch) {
        this.$fetch = fetch;
    }

    call<T>({
        method,
        url,
        fetchOptions,
        body,
        withToken = true,
    }: IHttpFactory): Promise<T> {
        const token = useCookie(CookiesNames.TOKEN);
        return this.$fetch<T>(url, {
            method,
            body,
            headers: {
                'Content-Type': 'application/json',
                ...(withToken && token.value
                    ? { 'x-auth-token': token.value }
                    : {}),
            },
            ...fetchOptions,
        });
    }
}
export default HttpFactory;
